"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STAR_NUM_TO_STATE = exports.STATE_TO_QUERY = exports.SORT = exports.FILTER = exports.DESC = exports.ASC = exports.HELPFUL = exports.OVERALL = exports.CREATED_AT = exports.PAGE_KEY = exports.SORT_KEY = exports.FILTER_KEY = exports.REVIEWS_PER_PAGE = exports.MOST_HELPFUL = exports.LOWEST = exports.HIGHEST = exports.OLDEST = exports.NEWEST = exports.ONE_STAR = exports.TWO_STARS = exports.THREE_STARS = exports.FOUR_STARS = exports.FIVE_STARS = exports.ALL = exports.MINIMUM_REVIEWS_FOR_DISPLAY = void 0;

var _immutable = _interopRequireDefault(require("immutable"));

// Display
var MINIMUM_REVIEWS_FOR_DISPLAY = 3; // Filter options

exports.MINIMUM_REVIEWS_FOR_DISPLAY = MINIMUM_REVIEWS_FOR_DISPLAY;
var ALL = 'ALL';
exports.ALL = ALL;
var FIVE_STARS = 'FIVE_STARS';
exports.FIVE_STARS = FIVE_STARS;
var FOUR_STARS = 'FOUR_STARS';
exports.FOUR_STARS = FOUR_STARS;
var THREE_STARS = 'THREE_STARS';
exports.THREE_STARS = THREE_STARS;
var TWO_STARS = 'TWO_STARS';
exports.TWO_STARS = TWO_STARS;
var ONE_STAR = 'ONE_STAR'; // Sort options

exports.ONE_STAR = ONE_STAR;
var NEWEST = 'NEWEST';
exports.NEWEST = NEWEST;
var OLDEST = 'OLDEST';
exports.OLDEST = OLDEST;
var HIGHEST = 'HIGHEST';
exports.HIGHEST = HIGHEST;
var LOWEST = 'LOWEST';
exports.LOWEST = LOWEST;
var MOST_HELPFUL = 'MOST_HELPFUL'; // Pagination

exports.MOST_HELPFUL = MOST_HELPFUL;
var REVIEWS_PER_PAGE = 10; // Text keys for local state

exports.REVIEWS_PER_PAGE = REVIEWS_PER_PAGE;
var FILTER_KEY = 'FILTER';
exports.FILTER_KEY = FILTER_KEY;
var SORT_KEY = 'SORT';
exports.SORT_KEY = SORT_KEY;
var PAGE_KEY = 'PAGE'; // sortField for BE

exports.PAGE_KEY = PAGE_KEY;
var CREATED_AT = 'CREATED_AT';
exports.CREATED_AT = CREATED_AT;
var OVERALL = 'OVERALL';
exports.OVERALL = OVERALL;
var HELPFUL = 'HELPFUL'; // sortOrder for BE

exports.HELPFUL = HELPFUL;
var ASC = 'ASC';
exports.ASC = ASC;
var DESC = 'DESC';
exports.DESC = DESC;
var FILTER = {
  ALL: ALL,
  FIVE_STARS: FIVE_STARS,
  FOUR_STARS: FOUR_STARS,
  THREE_STARS: THREE_STARS,
  TWO_STARS: TWO_STARS,
  ONE_STAR: ONE_STAR
};
exports.FILTER = FILTER;
var SORT = {
  NEWEST: NEWEST,
  OLDEST: OLDEST,
  HIGHEST: HIGHEST,
  LOWEST: LOWEST,
  MOST_HELPFUL: MOST_HELPFUL
};
exports.SORT = SORT;
var STATE_TO_QUERY = {
  // FILTER
  ALL: {
    overallFilter: [1, 2, 3, 4, 5]
  },
  FIVE_STARS: {
    overallFilter: [5]
  },
  FOUR_STARS: {
    overallFilter: [4]
  },
  THREE_STARS: {
    overallFilter: [3]
  },
  TWO_STARS: {
    overallFilter: [2]
  },
  ONE_STAR: {
    overallFilter: [1]
  },
  // SORT
  NEWEST: {
    sortField: CREATED_AT,
    sortOrder: DESC
  },
  OLDEST: {
    sortField: CREATED_AT,
    sortOrder: ASC
  },
  HIGHEST: {
    sortField: OVERALL,
    sortOrder: DESC
  },
  LOWEST: {
    sortField: OVERALL,
    sortOrder: ASC
  },
  MOST_HELPFUL: {
    sortField: HELPFUL,
    sortOrder: DESC
  }
};
exports.STATE_TO_QUERY = STATE_TO_QUERY;
var STAR_NUM_TO_STATE = new _immutable.default.Map({
  1: FILTER.ONE_STAR,
  2: FILTER.TWO_STARS,
  3: FILTER.THREE_STARS,
  4: FILTER.FOUR_STARS,
  5: FILTER.FIVE_STARS
});
exports.STAR_NUM_TO_STATE = STAR_NUM_TO_STATE;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/reviews/ReviewsListQueries.js
// module id = 188
// module chunks = 209 210 211 212